import type { ColumnConfig } from '@/components/configure-columns-dialog';

// Default column configuration for the Audit Trail screen
export const DEFAULT_AUDIT_COLUMNS: ColumnConfig[] = [
  // Default columns (visible by default)
  { id: 'timestamp', label: 'Timestamp', visible: true, order: 0, group: 'default' },
  { id: 'assetCode', label: 'Asset Code', visible: true, order: 1, group: 'default' },
  { id: 'assetName', label: 'Description', visible: true, order: 2, group: 'default' },
  { id: 'user', label: 'User', visible: true, order: 3, group: 'default' },
  { id: 'actionType', label: 'Action', visible: true, order: 4, group: 'default' },
  { id: 'field', label: 'Field', visible: true, order: 5, group: 'default' },
  { id: 'changes', label: 'Changes', visible: true, order: 6, group: 'default' },
];

export const AUDIT_COLUMNS_STORAGE_KEY = 'audit-trail-columns-config';
